import { useEffect, useContext } from "react";
import { Animated } from "react-animated-css";
import Loadding from "./../carCapture/images/loading.svg";
import IMGHuy from "./../acsset/img-huy.png";
import IMGHoantat from "./../acsset/img-hoantat.png";
import IMGChoPheDuyet from "./../acsset/img-chopheduyet.png";

import Load from "./../carCapture/images/load.gif";
import { AuthContext } from "./index";

const Validate = (props) => {
  /**
       * 1 - cho chup hinh
       * 2 - cho phe duyet => liberty se dc cap giay va duyet hinh anh sau
       * 3 - hoan thanh
       * 4 - bo sung hinh anh
       * 5 - chờ huỷ / hết hạn chụp hình
       * 6 - huy
       */
  const { isMobile, dataCheckupload} = useContext(AuthContext);

  useEffect(() => {
    //cho api
  }, []);

  const css = {};

  return (
    <>
      <Animated
        animationIn="slideInUp"
        animationInDuration={500}
        isVisible={true}
        style={{ with: "100%", height: "100%" }}
      >
        <div
          style={{
            width: "100%",
            height: isMobile ? 'calc(100vh - 125px)' : 'calc(100vh - 135px)',
            color: "#646D69",
            display: 'grid',
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {!+dataCheckupload?.status && (
            <div style={{ textAlign: "center", display: 'grid', gap: 5 }}>
              <img src={Loadding} />
              <div>
                <img src={Load} style={{ width: "60px" }} />
              </div>
              <div style={{ color: "#343A40", fontWeight: 600, fontSize: 18 }}>
                Đang kiểm tra
              </div>
              <div style={{ fontSize: 16, color: '#646D69' }}>
                Đơn hàng đang được kiểm tra...
              </div>
            </div>
          )}

          {+dataCheckupload?.status === 5 && (
            <div style={{ textAlign: "center" }}>
              <img src={Loadding} />
              <div style={{ color: "#343A40", fontWeight: 600, marginTop: 15, fontSize: 18 }}>
                Hết hạn chụp hình
              </div>
            </div>
          )}

          {+dataCheckupload?.status === 6 && (
            <div style={{ textAlign: "center" }}>
              <img src={IMGHuy} width={'187px'} />
              <div style={{ color: "#343A40", fontWeight: 600, marginTop: 15, fontSize: 18 }}>
                Đơn bảo hiểm bị hủy
              </div>
            </div>
          )}

          {+dataCheckupload?.status === 2 && (
            <div style={{ textAlign: "center" }}>
              <img src={IMGChoPheDuyet} width={'273px'} />
              <div style={{ color: "#343A40", fontWeight: 600, marginTop: 15, fontSize: 18 }}>
                Chờ phê duyệt
              </div>
              <div style={{ marginTop: 15, fontSize: 16, color: '#646D69' }}>
                Bạn đã hoàn thành bước chụp hình hệ thống đang kiểm tra và xử lý
              </div>
            </div>
          )}

          {+dataCheckupload?.status === 3 && (
            <div style={{ textAlign: "center" }}>
              <img src={IMGHoantat} width={'200px'} />
              <div style={{ color: "#343A40", fontWeight: 600, marginTop: 15, fontSize: 18 }}>
                Hoàn tất
              </div>
              <div style={{ marginTop: 15, fontSize: 16, color: '#646D69' }}>Đơn hàng đã được hoàn tất</div>
            </div>
          )}
        </div>
      </Animated>
    </>
  );
};

export default Validate;
